import { render } from "./StatusFooter.vue?vue&type=template&id=245b2356"
import script from "./StatusFooter.vue?vue&type=script&lang=js"
export * from "./StatusFooter.vue?vue&type=script&lang=js"

import "./StatusFooter.vue?vue&type=style&index=0&id=245b2356&lang=css"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__